import {
  SET_USER, REMOVE_USER, SESSION_LOADED,
} from '../actions/actionTypes'


const initialState = {
  user: null,
  isEmployee: false,
  sessionLoaded: false,
};

const userReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {

    case SET_USER:
      return {
        ...newState,
        user: action.payload,
        sessionLoaded: true,
      };

    case REMOVE_USER:
      return {...newState, user: null}

    case SESSION_LOADED:
      return {...newState, sessionLoaded: true}

    default:
      return newState;

    }
};

export default userReducer;